import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import LogInModal from 'flarum/forum/components/LogInModal';
import NagusiBackNav from '../common/NagusiBackNav';
export default class MundialVotePage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "saving", false);
    _defineProperty(this, "deadline", null);
    _defineProperty(this, "isClosed", false);
    _defineProperty(this, "teams", []);
    _defineProperty(this, "userVote", null);
    _defineProperty(this, "selectedTeamPot1Id", null);
    _defineProperty(this, "selectedTeamPot2Id", null);
    _defineProperty(this, "selectedTeamPot3Id", null);
    _defineProperty(this, "selectedTeamPot4Id", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadData();
  }
  loadData() {
    this.loading = true;
    this.deadline = new Date('2026-06-11T17:00:00+02:00');
    this.isClosed = new Date() > this.deadline;
    const pTeams = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/mundial-teams'
    });
    const promises = [pTeams];
    if (app.session.user) {
      promises.push(app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/mundial-vote'
      }).catch(() => null));
    }
    Promise.all(promises).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        teamsResp = _ref2[0],
        voteResp = _ref2[1];
      this.teams = app.store.pushPayload(teamsResp) || [];
      if (voteResp && voteResp.data) {
        this.userVote = voteResp.data;
        const attrs = voteResp.data.attributes;
        this.selectedTeamPot1Id = attrs.teamPot1Id || null;
        this.selectedTeamPot2Id = attrs.teamPot2Id || null;
        this.selectedTeamPot3Id = attrs.teamPot3Id || null;
        this.selectedTeamPot4Id = attrs.teamPot4Id || null;
      }
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  saveVote() {
    if (this.isClosed || !app.session.user) return;
    if (!this.selectedTeamPot1Id || !this.selectedTeamPot2Id || !this.selectedTeamPot3Id || !this.selectedTeamPot4Id) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('nagusi-match-ratings.forum.mundial.error_select_each_pot'));
      return;
    }
    this.saving = true;
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/mundial-vote',
      body: {
        data: {
          attributes: {
            teamPot1Id: this.selectedTeamPot1Id,
            teamPot2Id: this.selectedTeamPot2Id,
            teamPot3Id: this.selectedTeamPot3Id,
            teamPot4Id: this.selectedTeamPot4Id
          }
        }
      }
    }).then(response => {
      this.saving = false;
      this.userVote = response.data;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('nagusi-match-ratings.forum.mundial.success_saved'));
      m.redraw();
    }).catch(() => {
      this.saving = false;
      m.redraw();
    });
  }
  selectTeam(pot, teamId) {
    if (this.isClosed) return;
    if (pot === 1) this.selectedTeamPot1Id = teamId;
    if (pot === 2) this.selectedTeamPot2Id = teamId;
    if (pot === 3) this.selectedTeamPot3Id = teamId;
    if (pot === 4) this.selectedTeamPot4Id = teamId;
    m.redraw();
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "BolillaPage"
      }, m(LoadingIndicator, null));
    }
    const pot1Teams = this.teams.filter(t => t.pot() === 1);
    const pot2Teams = this.teams.filter(t => t.pot() === 2);
    const pot3Teams = this.teams.filter(t => t.pot() === 3);
    const pot4Teams = this.teams.filter(t => t.pot() === 4);
    const isReadOnly = this.isClosed || !app.session.user;
    return m("div", {
      className: "BolillaPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      parentUrl: "/aurrera-jokoak",
      parentLabel: "Aurrera Jokoak",
      title: "Mundial 2026"
    }), m("h2", {
      className: "BolillaPage-Title"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.porrita_title')), m("div", {
      className: "JokoakSubmenu",
      style: "display: flex; gap: 15px; margin-bottom: 25px; justify-content: center; background: #fff; padding: 10px; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.04); border: 1px solid rgba(0,0,0,0.06);"
    }, m(Link, {
      href: "/mundial-2026/clasificacion",
      className: "JokoakSubmenu-link",
      style: "padding: 8px 20px; border-radius: 20px; font-weight: bold; font-size: 13px; text-decoration: none; color: #666; background: transparent; transition: all 0.2s;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.classification_tab')), m(Link, {
      href: "/mundial-2026/selecciones",
      className: "JokoakSubmenu-link",
      style: "padding: 8px 20px; border-radius: 20px; font-weight: bold; font-size: 13px; text-decoration: none; color: #666; background: transparent; transition: all 0.2s;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.teams_tab'))), !app.session.user ? m("div", {
      className: "BolillaWidget-GuestMessageWrapper",
      style: "text-align: center; padding: 25px 15px; background: #fff; border-radius: 16px; border: 1px solid rgba(0,0,0,0.08); box-shadow: 0 4px 20px rgba(0,0,0,0.04); margin-bottom: 40px;"
    }, m("p", {
      className: "BolillaWidget-GuestMessage",
      style: "margin-bottom: 15px; font-weight: 500;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.login_to_participate')), m(Button, {
      className: "Button Button--primary",
      onclick: () => app.modal.show(LogInModal)
    }, m("i", {
      className: "fas fa-sign-in-alt",
      style: "margin-right: 6px;"
    }), app.translator.trans('nagusi-match-ratings.forum.mundial.access_forum'))) : this.isClosed ? m("div", {
      className: "Alert Alert--warning",
      style: "margin-bottom: 30px; border-radius: 12px; padding: 15px 20px; display: flex; align-items: center; gap: 12px;"
    }, m("i", {
      className: "fas fa-lock",
      style: "font-size: 1.2em;"
    }), m("span", null, m("strong", null, app.translator.trans('nagusi-match-ratings.forum.mundial.predictions_closed_label')), " ", app.translator.trans('nagusi-match-ratings.forum.mundial.predictions_closed_text'))) : this.deadline && m("div", {
      className: "Alert Alert--info",
      style: "margin-bottom: 30px; border-radius: 12px; padding: 15px 20px; display: flex; align-items: center; gap: 12px;"
    }, m("i", {
      className: "far fa-clock",
      style: "font-size: 1.2em;"
    }), m("span", null, app.translator.trans('nagusi-match-ratings.forum.mundial.can_change_until', {
      date: this.deadline.toLocaleString()
    }))), m("div", {
      style: "background: #fff; padding: 25px; border-radius: 16px; box-shadow: 0 4px 15px rgba(0,0,0,0.05); border: 1px solid #eee; margin-bottom: 40px;"
    }, m("h3", {
      style: "font-size: 1.4em; font-weight: bold; margin: 0 0 10px 0;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.choose_one_per_pot')), m("div", {
      style: "color: #666; font-size: 13px; margin-bottom: 25px; line-height: 1.6;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.points_rules_intro'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_groups'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_phases'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_champion'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_runnerup'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_third_fourth'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_top_scorer'), m("br", null), "\u2022 ", app.translator.trans('nagusi-match-ratings.forum.mundial.points_rule_mvp'), m("br", null), m("br", null), m("strong", {
      style: "color: #EE2523;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.deadline_text'))), [1, 2, 3, 4].map(potNum => {
      const potTeams = potNum === 1 ? pot1Teams : potNum === 2 ? pot2Teams : potNum === 3 ? pot3Teams : pot4Teams;
      const selectedId = potNum === 1 ? this.selectedTeamPot1Id : potNum === 2 ? this.selectedTeamPot2Id : potNum === 3 ? this.selectedTeamPot3Id : this.selectedTeamPot4Id;
      return m("div", {
        style: "margin-bottom: 35px; border-bottom: 1px solid #f0f0f0; padding-bottom: 25px;"
      }, m("h4", {
        style: "font-weight: 800; font-size: 1.2em; margin-bottom: 15px; color: #333; display: flex; align-items: center; gap: 8px;"
      }, m("span", {
        style: "background: ".concat(potNum === 1 ? '#EE2523' : potNum === 2 ? '#EF6C00' : potNum === 3 ? '#4CAF50' : '#9C27B0', "; color: #fff; border-radius: 6px; padding: 2px 8px; font-size: 0.8em; white-space: nowrap; display: inline-block;")
      }, app.translator.trans('nagusi-match-ratings.forum.mundial.pot_label', {
        pot: potNum
      }))), m("div", {
        style: "display: grid; grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 12px;"
      }, potTeams.map(team => {
        const isSelected = selectedId === parseInt(team.id());
        return m("div", {
          onclick: () => this.selectTeam(potNum, parseInt(team.id())),
          style: "\n                                                        padding: 15px 12px;\n                                                        border-radius: 10px;\n                                                        border: 2px solid ".concat(isSelected ? '#EE2523' : '#f0f0f0', ";\n                                                        background: ").concat(isSelected ? 'rgba(238, 37, 35, 0.05)' : '#fafafa', ";\n                                                        text-align: center;\n                                                        font-weight: ").concat(isSelected ? 'bold' : 'normal', ";\n                                                        color: ").concat(isSelected ? '#EE2523' : '#333', ";\n                                                        cursor: ").concat(isReadOnly ? 'default' : 'pointer', ";\n                                                        transition: all 0.2s ease-in-out;\n                                                        display: flex;\n                                                        align-items: center;\n                                                        justify-content: center;\n                                                        box-shadow: ").concat(isSelected ? '0 4px 10px rgba(238,37,35,0.1)' : 'none', ";\n                                                    "),
          oncreate: vnode => {
            const el = vnode.dom;
            if (!isReadOnly) {
              el.addEventListener('mouseenter', () => {
                if (!isSelected) el.style.borderColor = '#ccc';
              });
              el.addEventListener('mouseleave', () => {
                if (!isSelected) el.style.borderColor = '#f0f0f0';
              });
            }
          }
        }, team.name());
      })));
    }), !isReadOnly && m("div", {
      style: "text-align: center; margin-top: 30px;"
    }, m(Button, {
      className: "Button Button--primary",
      style: "padding: 12px 35px; border-radius: 30px; font-weight: bold; font-size: 1.1em; background: #EE2523; border: none; height: 50px;",
      onclick: () => this.saveVote(),
      loading: this.saving
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.save_predictions'))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/mundial/MundialVotePage', MundialVotePage);